<div nz-row nzGutter="25">
  <div nz-col nzXs="24" nzXl="12" class="mb-[25px]">
    <div class="bg-white dark:bg-white/10 mb-[25px] p-0 text-theme-gray dark:text-white/60 text-[15px] rounded-10 relative">
      <div class="px-[25px] py-[15px] text-dark dark:text-white/[.87] font-medium text-[17px] flex flex-wrap items-center justify-between max-sm:flex-col max-sm:h-auto max-sm:mb-[15px] border-b border-[#F1F2F6] dark:border-white/10">
        <h4 class="mb-0 text-lg font-medium text-dark dark:text-white/[.87] capitalize">Basic</h4>
      </div>
      <div class="p-[25px]">
        <nz-demo-drawer-basic-right></nz-demo-drawer-basic-right>
      </div>
    </div>
    <div class="bg-white dark:bg-white/10 mb-[25px] p-0 text-theme-gray dark:text-white/60 text-[15px] rounded-10 relative">
      <div class="px-[25px] py-[15px] text-dark dark:text-white/[.87] font-medium text-[17px] flex flex-wrap items-center justify-between max-sm:flex-col max-sm:h-auto max-sm:mb-[15px] border-b border-[#F1F2F6] dark:border-white/10">
        <h4 class="mb-0 text-lg font-medium text-dark dark:text-white/[.87] capitalize">Edit item in drawer</h4>
      </div>
      <div class="p-[25px]">
        <nz-demo-drawer-from-drawer></nz-demo-drawer-from-drawer>
      </div>
    </div>
    <div class="bg-white dark:bg-white/10 mb-[25px] p-0 text-theme-gray dark:text-white/60 text-[15px] rounded-10 relative">
      <div class="px-[25px] py-[15px] text-dark dark:text-white/[.87] font-medium text-[17px] flex flex-wrap items-center justify-between max-sm:flex-col max-sm:h-auto max-sm:mb-[15px] border-b border-[#F1F2F6] dark:border-white/10">
        <h4 class="mb-0 text-lg font-medium text-dark dark:text-white/[.87] capitalize">Multi-level drawer</h4>
      </div>
      <div class="p-[25px]">
        <nz-demo-drawer-multi-level-drawer></nz-demo-drawer-multi-level-drawer>
      </div>
    </div>
  </div>
  <div nz-col nzXs="24" nzXl="12" class="mb-[25px]">
    <div class="bg-white dark:bg-white/10 mb-[25px] p-0 text-theme-gray dark:text-white/60 text-[15px] rounded-10 relative">
      <div class="px-[25px] py-[15px] text-dark dark:text-white/[.87] font-medium text-[17px] flex flex-wrap items-center justify-between max-sm:flex-col max-sm:h-auto max-sm:mb-[15px] border-b border-[#F1F2F6] dark:border-white/10">
        <h4 class="mb-0 text-lg font-medium text-dark dark:text-white/[.87] capitalize">Custom Placement
        </h4>
      </div>
      <div class="p-[25px]">
        <nz-demo-drawer-placement></nz-demo-drawer-placement>
      </div>
    </div>
    <div class="bg-white dark:bg-white/10 mb-[25px] p-0 text-theme-gray dark:text-white/60 text-[15px] rounded-10 relative">
      <div class="px-[25px] py-[15px] text-dark dark:text-white/[.87] font-medium text-[17px] flex flex-wrap items-center justify-between max-sm:flex-col max-sm:h-auto max-sm:mb-[15px] border-b border-[#F1F2F6] dark:border-white/10">
        <h4 class="mb-0 text-lg font-medium text-dark dark:text-white/[.87] capitalize">Preview drawer
        </h4>
      </div>
      <div class="p-[25px]">
        <nz-demo-drawer-user-profile></nz-demo-drawer-user-profile>
      </div>
    </div>
    <div class="bg-white dark:bg-white/10 mb-[25px] p-0 text-theme-gray dark:text-white/60 text-[15px] rounded-10 relative">
      <div class="px-[25px] py-[15px] text-dark dark:text-white/[.87] font-medium text-[17px] flex flex-wrap items-center justify-between max-sm:flex-col max-sm:h-auto max-sm:mb-[15px] border-b border-[#F1F2F6] dark:border-white/10">
        <h4 class="mb-0 text-lg font-medium text-dark dark:text-white/[.87] capitalize">Drawer's service
        </h4>
      </div>
      <div class="p-[25px]">
        <nz-demo-drawer-service></nz-demo-drawer-service>
      </div>
    </div>
  </div>
</div>
